import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "eventra_token";

const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
  }
  return String(detail);
}

export function apiErr(e) {
  if (e?.response?.status === 502) {
    const url = e?.config?.url || "";
    const data = typeof e?.config?.data === "string" ? e.config.data : "";
    const isOtpDelivery = url.includes("/auth/register")
      || url.includes("/auth/resend-otp")
      || url.includes("/auth/login")
      || url.includes("/auth/forgot-password")
      || url.includes("/auth/change-contact/request")
      || url.includes("/auth/mobile/request")
      || url.includes("/auth/mobile/signup")
      || url.includes("/organizer/onboarding/mobile/request");
    if (!isOtpDelivery) {
      const detail = e?.response?.data?.detail;
      if (detail) return fmtErr(detail);
      return "Service temporarily unavailable. Please try again.";
    }
    const isSms = url.includes("/mobile/")
      || url.includes("/organizer/onboarding/mobile")
      || data.includes('"field":"mobile"');
    return isSms
      ? "Unable to send OTP SMS. Please try again."
      : "Unable to send OTP email. Please try again.";
  }
  return fmtErr(e?.response?.data?.detail) || e?.message || "Network error";
}

export function money(n, symbol = "₹") {
  const v = Number(n || 0);
  return symbol + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 }).format(v);
}

export default api;
